// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/817946b6d084a01b5dc5.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"2686775f4e4f4e9ee71f","191":"057dc1d9d3d306961226","192":"60879a3a3f4a31fa2a31"}[chunkId] + ".chunk.js";
};